export class UserSecurityAccess {
  isCommandCenterAccess: boolean = false;
  isSeedAccess: boolean = false;
  isOTIAccess: boolean = false;
  isOrderAccess: boolean = false;
  isDealerOrderAccess: boolean = false;
  isAccountAccess: boolean = false;
  isFulfillmentAccess: boolean = false;
  isDeliveryInstructionsAccess: boolean = false;
  isReportAccess: boolean = false;
  isLicenseAccess: boolean = false;
  isEmulationAccess: boolean = false;
  isQosSearchAccess: boolean = false;
  isPAvailabilityAccess: boolean = false;
  isDOAuditAccess: boolean = false;
  isGOAuditAccess: boolean = false;
  isShippableProducts: boolean = false;
  isSubstitutionOrderReport: boolean = false;
  isShippingAvailabilityReport: boolean = false;
  isTOSAccess: boolean = false;
  isPrepayAccess: boolean = false;
  isCPPtabAccess: boolean = false;
  isCPPOrderAccess: boolean = false;
  isMarketingProgramAccess: boolean = false;
  isCPPErrorAccess: boolean = false;
  isCPPPriceListAccess: boolean = false;
  isCPPDeliveryInstructionAccess: boolean = false;
  isSRAAccess: boolean = false;
  isCPPReportAccess: boolean = false;
  isSeedReturnAccess: boolean = false;
  isCPPReturnsAccess: boolean = false;
  isCPPProductReturnsAccess: boolean = false;
  isCPPContainerReturnsAccess: boolean = false;
  isSeedReplantAccess: boolean = false;
  isSOTStockTransferAccess: boolean = false;
  issubscriptionMgtAccess: boolean = false;
  isGrowerProgramsAccess: boolean = false;
  isSeedDiscretionaryAccess: boolean = false;
  partnerAccessTypeMode: boolean = false;
  isCPPCOIAccess: boolean = false;
  isSRAOrderAccess: boolean = false;
  isSeedReservationAccess: boolean = false;
  isSraApproversAccess: boolean = false;
  isCPPUserListAccess: boolean = false;
  isSeedCropAssociatesAccess: boolean = false;
  isPlotSeedAccess: boolean = false;
  isAssociateRenconciliationAccess: boolean = false;
  isAssociateInventoryAccess: boolean = false;
  isEDLPAccess: boolean = false;
  isPlotSeedReleaseAccess: boolean = false;
  isVirtualAssistantAccess: boolean = false;
  isProvingGroundSeedAccess: boolean = false;
}

export class SliderModel {
  appCppProductAdd: boolean = false;
  appBlanketProductAdd: boolean = false;
  appBlanketProductUploadAdd: boolean = false;
  appUpdateLicense: boolean = false;
  appUserReportFilter: boolean = false;
  appCppSraProductAdd: boolean = false;
  appProductAdd: boolean = false;
  appCppCoiAdd: boolean = false;
  appStockTransferAdd: boolean = false;
  appStockTransferRequestHistory: boolean = false;
  appStockTransferAccountAdd: boolean = false;
  appProductChange: boolean = false;
  appOrderTransfer: boolean = false;
  appDealerOrderTransfer: boolean = false;
  appDealerOrderInternalTransfer: boolean = false;
  appGrowerSearch: boolean = false;
  appRetailerSearch: boolean = false;
  appItemAvailabilityDetail: boolean = false;
  appdiffDealerGrowerOrderTransfer: boolean = false;
  appSeedReturnProductAdd: boolean = false;
  appCppReturnProductAdd: boolean = false;
  appCppForecastProductAdd: boolean = false;
  appSeedReplantOriginalProductAdd: boolean = false;
  appSeedReplantProductAdd: boolean = false;
  appSeedCropLossProductAdd: boolean = false;
  appProductLineDeliveryInstructionAdd: boolean = false;
  appcontainerReturnsProductAdd: boolean = false;
  appSeedFulfillmentBreakdownViewEdit: boolean = false;
  appPlotSeedReleaseBreakdownView: boolean = false;

  growerProgramBudgetSlider: boolean = false;
  growerProgramNameSlider: boolean = false;
  growerProgramCommentSlider: boolean = false;
  otiOrderDetailSlider: boolean = false;

  showSRACostSheetGlossary: boolean = false;
  eaSwapProductAdd: boolean = false;
  eaAddProductUnit: boolean = false;
  eaProductModifyDecreaseUnit: boolean = false;
  reconcileVarietySlider: boolean = false;
  seedReservationReconcileAddSlider: boolean = false;
  seedReservationReconcileAddHybridSlider: boolean = false;
  growerOrderHybridAddProductSlider: boolean = false;
  sraRequestDetailsSlider: boolean = false; 
}
